// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Muli:400,400i,700,700i);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body{
  font-family: 'Muli', sans-serif;
  background:transparent;
}
.shell{
  padding:80px 0;
}
.wsk-cp-product{
  background:#fff;
  padding:15px;
  border-radius:6px;
  box-shadow: 0 1px 3px transparent, 0 1px 2px transparent;
  position:relative;
  margin:20px auto;
}
.wsk-cp-img{
  position:absolute;
  top:5px;
  left:50%;
  transform:translate(-50%);
  -webkit-transform:translate(-50%);
  -ms-transform:translate(-50%);
  -moz-transform:translate(-50%);
  -o-transform:translate(-50%);
  -khtml-transform:translate(-50%);
  width: 100%;
  padding: 15px;
  transition: all 0.2s ease-in-out;
}
.wsk-cp-img img{
  width:100%;
  transition: all 0.2s ease-in-out;
  border-radius:6px;
}
.wsk-cp-product:hover .wsk-cp-img{
  top:-40px;
}
.wsk-cp-product:hover .wsk-cp-img img{
  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);
}
.wsk-cp-text{
  padding-top:100%;
}
.wsk-cp-text .category{
  text-align:center;
  font-size:12px;
  font-weight:bold;
  padding:5px;
  margin-bottom:45px;
  position:relative;
  transition: all 0.2s ease-in-out;
}
.wsk-cp-text .category > *{
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  -webkit-transform: translate(-50%,-50%);
  -moz-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  -o-transform: translate(-50%,-50%);
  -khtml-transform: translate(-50%,-50%);
    
}
.wsk-cp-text .category > span{
  padding: 12px 30px;
  border: 1px solid transparent;
  background:#03AC13;
  color:#fff;
  box-shadow: 0 19px 38px transparent, 0 15px 12px transparent;
  border-radius:27px;
  transition: all 0.05s ease-in-out;
  width: 60%;
}
.wsk-cp-product:hover .wsk-cp-text .category > span{
  border-color:#ddd;
  box-shadow: none;
  padding: 11px 28px;
}
.wsk-cp-product:hover .wsk-cp-text .category{
  margin-top: 0px;
}
.wsk-cp-text .title-product{
  text-align:center;
}
.wsk-cp-text .title-product h3{
  font-size:20px;
  font-weight:bold;
  margin:15px auto;
  overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  width:100%;
}
.wsk-cp-text .description-prod p{
  margin:0;
}
/* Truncate */
.wsk-cp-text .description-prod {
  text-align:center;
  width: 100%;
  height:62px;
  overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  margin-bottom:15px;
}
.card-footer{
  padding: 25px 0 5px;
  border-top: 1px solid #ddd;
}
.card-footer:after, .card-footer:before{
  content:'';
  display:table;
}
.card-footer:after{
  clear:both;
}

.card-footer .wcf-left{
  float:left;
  
}

.card-footer .wcf-right{
  float:right;
}

.price{
  font-size:18px;
  font-weight:bold;
}

a.buy-btn{
  display:block;
  color:#fff;
  text-align:center;
  font-size: 18px;
  width:35px;
  height:35px;
  line-height:35px;
  border-radius:50%;
  border:1px solid #fff;
  transition: all 0.2s ease-in-out;
}
a.buy-btn:hover , a.buy-btn:active, a.buy-btn:focus{
  border-color: #FF9800;
  background: #FF9800;
  color: #fff;
  text-decoration:none;
}
.wsk-btn{
  display:inline-block;
  color:#00BB7E;
  text-align:center;
  font-size: 18px;
  transition: all 0.2s ease-in-out;
  border-color: #FF9800;
  background: #FF9800;
  padding:12px 30px;
  border-radius:27px;
  margin: 0 5px;
}
.wsk-btn:hover, .wsk-btn:focus, .wsk-btn:active{
  text-decoration:none;
  color:#fff;
}  
.red{
  color:#F44336;
  font-size:22px;
  display:inline-block;
  margin: 0 5px;
}
@media screen and (max-width: 991px) {
  .wsk-cp-product{
    margin:40px auto;
  }
  .wsk-cp-product .wsk-cp-img{
  top:-40px;
}
.wsk-cp-product .wsk-cp-img img{
  box-shadow: 0 19px 38px #03AC13, 0 15px 12px #03AC13;
}
  .wsk-cp-product .wsk-cp-text .category > span{
  border-color:#ddd;
  box-shadow: none;
  padding: 11px 28px;
}
.wsk-cp-product .wsk-cp-text .category{
  margin-top: 0px;
}
a.buy-btn{
  border-color: #FF9800;
  background: #FF9800;
  color: #fff;
}
}

.last:last-child{
	justify-content: center;
	margin-left: auto;
	margin-right: auto;
	justify-items: center;
	justify-self: center;
	text-align: center;
	align-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/ProductItems.css"],"names":[],"mappings":"AACA;EACE,+BAA+B;EAC/B,sBAAsB;AACxB;AACA;EACE,cAAc;AAChB;AACA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,wDAAwD;EACxD,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,yBAAyB;EACzB,iCAAiC;EACjC,6BAA6B;EAC7B,8BAA8B;EAC9B,4BAA4B;EAC5B,gCAAgC;EAChC,WAAW;EACX,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,UAAU;EACV,gCAAgC;EAChC,iBAAiB;AACnB;AACA;EACE,SAAS;AACX;AACA;EACE,sEAAsE;AACxE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,OAAO;EACP,QAAQ;EACR,+BAA+B;EAC/B,uCAAuC;EACvC,oCAAoC;EACpC,mCAAmC;EACnC,kCAAkC;EAClC,sCAAsC;;AAExC;AACA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,4DAA4D;EAC5D,kBAAkB;EAClB,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;IACd,mBAAmB;IACnB,uBAAuB;EACzB,UAAU;AACZ;AACA;EACE,QAAQ;AACV;AACA,aAAa;AACb;EACE,iBAAiB;EACjB,WAAW;EACX,WAAW;EACX,gBAAgB;IACd,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;EAC9B,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,aAAa;AACf;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;;AAEZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,eAAe;EACf,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,gCAAgC;AAClC;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;AACtB;AACA;EACE,oBAAoB;EACpB,aAAa;EACb,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;AACA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;EACpB,aAAa;AACf;AACA;EACE;IACE,gBAAgB;EAClB;EACA;EACA,SAAS;AACX;AACA;EACE,oDAAoD;AACtD;EACE;EACA,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;AACb;AACA;;AAEA;CACC,uBAAuB;CACvB,iBAAiB;CACjB,kBAAkB;CAClB,qBAAqB;CACrB,oBAAoB;CACpB,kBAAkB;CAClB,qBAAqB;AACtB","sourcesContent":["@import url('https://fonts.googleapis.com/css?family=Muli:400,400i,700,700i');\nbody{\n  font-family: 'Muli', sans-serif;\n  background:transparent;\n}\n.shell{\n  padding:80px 0;\n}\n.wsk-cp-product{\n  background:#fff;\n  padding:15px;\n  border-radius:6px;\n  box-shadow: 0 1px 3px transparent, 0 1px 2px transparent;\n  position:relative;\n  margin:20px auto;\n}\n.wsk-cp-img{\n  position:absolute;\n  top:5px;\n  left:50%;\n  transform:translate(-50%);\n  -webkit-transform:translate(-50%);\n  -ms-transform:translate(-50%);\n  -moz-transform:translate(-50%);\n  -o-transform:translate(-50%);\n  -khtml-transform:translate(-50%);\n  width: 100%;\n  padding: 15px;\n  transition: all 0.2s ease-in-out;\n}\n.wsk-cp-img img{\n  width:100%;\n  transition: all 0.2s ease-in-out;\n  border-radius:6px;\n}\n.wsk-cp-product:hover .wsk-cp-img{\n  top:-40px;\n}\n.wsk-cp-product:hover .wsk-cp-img img{\n  box-shadow: 0 19px 38px rgba(0,0,0,0.30), 0 15px 12px rgba(0,0,0,0.22);\n}\n.wsk-cp-text{\n  padding-top:100%;\n}\n.wsk-cp-text .category{\n  text-align:center;\n  font-size:12px;\n  font-weight:bold;\n  padding:5px;\n  margin-bottom:45px;\n  position:relative;\n  transition: all 0.2s ease-in-out;\n}\n.wsk-cp-text .category > *{\n  position:absolute;\n  top:50%;\n  left:50%;\n  transform: translate(-50%,-50%);\n  -webkit-transform: translate(-50%,-50%);\n  -moz-transform: translate(-50%,-50%);\n  -ms-transform: translate(-50%,-50%);\n  -o-transform: translate(-50%,-50%);\n  -khtml-transform: translate(-50%,-50%);\n    \n}\n.wsk-cp-text .category > span{\n  padding: 12px 30px;\n  border: 1px solid transparent;\n  background:#03AC13;\n  color:#fff;\n  box-shadow: 0 19px 38px transparent, 0 15px 12px transparent;\n  border-radius:27px;\n  transition: all 0.05s ease-in-out;\n  width: 60%;\n}\n.wsk-cp-product:hover .wsk-cp-text .category > span{\n  border-color:#ddd;\n  box-shadow: none;\n  padding: 11px 28px;\n}\n.wsk-cp-product:hover .wsk-cp-text .category{\n  margin-top: 0px;\n}\n.wsk-cp-text .title-product{\n  text-align:center;\n}\n.wsk-cp-text .title-product h3{\n  font-size:20px;\n  font-weight:bold;\n  margin:15px auto;\n  overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  width:100%;\n}\n.wsk-cp-text .description-prod p{\n  margin:0;\n}\n/* Truncate */\n.wsk-cp-text .description-prod {\n  text-align:center;\n  width: 100%;\n  height:62px;\n  overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3;\n    -webkit-box-orient: vertical;\n  margin-bottom:15px;\n}\n.card-footer{\n  padding: 25px 0 5px;\n  border-top: 1px solid #ddd;\n}\n.card-footer:after, .card-footer:before{\n  content:'';\n  display:table;\n}\n.card-footer:after{\n  clear:both;\n}\n\n.card-footer .wcf-left{\n  float:left;\n  \n}\n\n.card-footer .wcf-right{\n  float:right;\n}\n\n.price{\n  font-size:18px;\n  font-weight:bold;\n}\n\na.buy-btn{\n  display:block;\n  color:#fff;\n  text-align:center;\n  font-size: 18px;\n  width:35px;\n  height:35px;\n  line-height:35px;\n  border-radius:50%;\n  border:1px solid #fff;\n  transition: all 0.2s ease-in-out;\n}\na.buy-btn:hover , a.buy-btn:active, a.buy-btn:focus{\n  border-color: #FF9800;\n  background: #FF9800;\n  color: #fff;\n  text-decoration:none;\n}\n.wsk-btn{\n  display:inline-block;\n  color:#00BB7E;\n  text-align:center;\n  font-size: 18px;\n  transition: all 0.2s ease-in-out;\n  border-color: #FF9800;\n  background: #FF9800;\n  padding:12px 30px;\n  border-radius:27px;\n  margin: 0 5px;\n}\n.wsk-btn:hover, .wsk-btn:focus, .wsk-btn:active{\n  text-decoration:none;\n  color:#fff;\n}  \n.red{\n  color:#F44336;\n  font-size:22px;\n  display:inline-block;\n  margin: 0 5px;\n}\n@media screen and (max-width: 991px) {\n  .wsk-cp-product{\n    margin:40px auto;\n  }\n  .wsk-cp-product .wsk-cp-img{\n  top:-40px;\n}\n.wsk-cp-product .wsk-cp-img img{\n  box-shadow: 0 19px 38px #03AC13, 0 15px 12px #03AC13;\n}\n  .wsk-cp-product .wsk-cp-text .category > span{\n  border-color:#ddd;\n  box-shadow: none;\n  padding: 11px 28px;\n}\n.wsk-cp-product .wsk-cp-text .category{\n  margin-top: 0px;\n}\na.buy-btn{\n  border-color: #FF9800;\n  background: #FF9800;\n  color: #fff;\n}\n}\n\n.last:last-child{\n\tjustify-content: center;\n\tmargin-left: auto;\n\tmargin-right: auto;\n\tjustify-items: center;\n\tjustify-self: center;\n\ttext-align: center;\n\talign-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
